import { FC, useEffect } from 'react'

import { Preloader } from '@procom-labs/atoms'
import {
  AuthPortalRouteMaps,
  LoginTypes,
  useAuthService,
} from '@procom-labs/common'

export const AutoSsoMain: FC = () => {
  const authService = useAuthService()

  useEffect(() => {
    authService.redirectToAuthPortal(
      undefined,
      AuthPortalRouteMaps.AutoSso,
      LoginTypes.GorillaResume
    )
  }, [])

  return <Preloader center />
}
